class Country {
  /**
   * @param {Object} data
   * @param {number} data.id
   * @param {string} data.name
   */
  constructor({id, name}) {
    /** @type {number} */
    this.id = id;
    /** @type {string} */
    this.name = name;
  }
}

export default Country;